import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";

export function MembershipBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="membership-banner">
      <div className="rounded-2xl border border-[#FFD600]/30 bg-gradient-to-br from-[#FFD600]/10 via-slate-900/60 to-slate-900/40 p-6 sm:p-8 grid gap-6 lg:grid-cols-12 items-center">
        <div className="lg:col-span-7">
          <span className="dg-chip"><ShieldCheck className="w-3 h-3" /> New · Dr.Gadget Care membership</span>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight">David on call, every month.</h2>
          <p className="mt-3 text-slate-300 max-w-xl">Priority answers from Ask Dr.Gadget, 10% off every session and install — and Care+ includes a 30-minute phone or video session each month. Cancel anytime.</p>
        </div>
        <div className="lg:col-span-5 grid grid-cols-2 gap-3">
          {[{ id: "care", name: "Care", price: 19, note: "Priority + 10% off" }, { id: "care_plus", name: "Care+", price: 49, note: "+ a session every month" }].map((t) => (
            <Link key={t.id} to={`/membership?tier=${t.id}`} className="dg-card rounded-xl p-4 hover:border-[#FFD600]/60 transition-colors group" data-testid={`membership-banner-${t.id}`}>
              <div className="font-display font-semibold">{t.name}</div>
              <div className="font-display font-extrabold text-2xl text-[#FFD600] mt-1">${t.price}<span className="text-xs text-slate-400 font-normal">/mo</span></div>
              <div className="text-xs text-slate-400 mt-1">{t.note}</div>
              <div className="text-xs text-cyan-300 mt-3 flex items-center gap-1 group-hover:gap-2 transition-all">Join <ArrowRight className="w-3 h-3" /></div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
